/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StockLevelDto } from '../models/StockLevelDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StockLevelControllerService {
    /**
     * @param uuid
     * @returns StockLevelDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<StockLevelDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stock-levels/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns StockLevelDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: StockLevelDto,
    ): CancelablePromise<StockLevelDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stock-levels/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/stock-levels/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns StockLevelDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<StockLevelDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stock-levels',
        });
    }
    /**
     * @param requestBody
     * @returns StockLevelDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: StockLevelDto,
    ): CancelablePromise<StockLevelDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stock-levels',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param materialUuid
     * @returns StockLevelDto OK
     * @throws ApiError
     */
    public static getStockLevelsByMaterial(
        materialUuid: string,
    ): CancelablePromise<Array<StockLevelDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stock-levels/material/{materialUuid}',
            path: {
                'materialUuid': materialUuid,
            },
        });
    }
}
